<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Tehlike Sınıfı</label>
            <v-select-list :options="classes" v-model="hClass" label="Combined" placeholder="Tehlike Sınıfı"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">İSG Eğitimi</label>
            <input type="text" v-model="value.Name" class="form-control" placeholder="İSG Eğitimi"/>
        </div>
    </div>
</template>

<script>
import HazardClassApi from '@/api/hazard-class'

export default {
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            classes:[]
        }
    },
    mounted(){
        this.getHazardClasses()
    },
    methods:{
        getHazardClasses(){
            HazardClassApi.ListWithType(true).then(res => {
                this.classes= (res.data.Data || []).map(c => ({
                    ...c,
                    Combined:[c.ClassName,c.CategoryName].join(' - ')
                }))
            })
        }
    },
    computed:{
        hClass:{
            get:function(){
                return this.classes.find(b=>b.Id==this.value.HazardClassId)
            },
            set:function(value){
                this.value.HazardClassId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>